<template>
  <div>
    <div class="container-fluid mt--6 filter-show">
      <div class="abs-btn-grp-arbs">
        <div>
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <!-- Do Not Arb -->
            <button
              @click="showDonotarbModal()"
              type="button"
              class="btn btn-secondary rounded arbs-btn"
            >
              <i class="fas fa-ban mr-2"></i>DO NOT ARB
            </button>

            <!-- Munis Group -->
            <div class="btn-group shadow-sm" role="group">
              <button
                :disabled="loading || arbsUploadStatus == 'INPROGRESS'"
                v-if="!feedType"
                @click="suspendAll('munis')"
                type="button"
                class="btn rounded-left arbs-btn"
                style="background-color: #e96875; color: #fff; border: none"
              >
                <i class="fas fa-pause-circle mr-2"></i>SUSPEND MUNIS
              </button>
              <button
                @click="uploadAll('munis')"
                v-if="!feedType"
                :disabled="arbsUploadStatus == 'INPROGRESS'"
                type="button"
                class="btn rounded-right arbs-btn"
                style="background-color: #47734c; color: #fff; border: none"
              >
                <i v-if="loadingUpload" class="fa fa-spinner fa-spin mr-2"></i>
                <i v-else class="fas fa-upload mr-2"></i>UPLOAD MUNIS
              </button>
            </div>

            <!-- Corps Group -->
            <div class="btn-group shadow-sm" role="group">
              <button
                :disabled="loading || arbsUploadStatus == 'INPROGRESS'"
                @click="suspendAll('corps')"
                v-if="feedType"
                type="button"
                class="btn rounded-left arbs-btn"
                style="background-color: #e96875; color: #fff; border: none"

              >
                <i class="fas fa-pause-circle mr-2"></i>SUSPEND CORPS
              </button>
              <button
                @click="uploadAll('corps')"
                v-if="feedType"
                :disabled="arbsUploadStatus == 'INPROGRESS'"
                type="button"
                class="btn rounded-right arbs-btn"
                style="background-color: #47734c; color: #fff; border: none"

              >
                <i v-if="loadingUpload" class="fa fa-spinner fa-spin mr-2"></i>
                <i v-else class="fas fa-upload mr-2"></i>UPLOAD CORPS
              </button>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="mr-3 mt-1 text-white">
            <label class="form-label text-white">Munis Only?</label>
            <toggle-button
              :sync="true"
              v-model="feedType"
              :color="{
                checked: '#CE93D8',
                unchecked: '#2dce89',
                disabled: '#CCCCCC'
              }"
              @change="feedTypeChanged()"
            />
            <label class="form-label text-white">Corps Only?</label>
          </div>
          <div class="recap">
            <span style="color: #000">ARBS COUNT : </span>
            <span class="text-success">
              Held Off : {{ arbsFeedCount.totalHeldOff }}
            </span>
            <span class="text-warning">
              Suggested Arbs : {{ arbsFeedCount.totalSuggested }}
            </span>
            <span class="text-info">
              Arbs Sent : {{ arbsFeedCount.totalSent }}
            </span>
            <span
              @click="getFeedRecap()"
              class="fas fa-sync-alt cursor-pointer"
              v-bind:class="{ 'fa-spin': countLoading }"
              data-toggle="tooltip"
              data-placement="left"
              title="Refresh count"
              aria-hidden="true"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid filter-show mt-4">
      <div class="card w-100 p-2 mb-2 d-inline-block">
        <div class="d-flex justify-content-between">
          <h5 class="ml-3">Filters</h5>
          <span class="btn btn-link" @click="showFilters = !showFilters">
            <i
              class="fa"
              v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"
            ></i>
            {{ showFilters ? 'Hide' : 'Show' }} Filters
          </span>
        </div>
        <div class="row" v-if="showFilters">
          <div class="col-lg-12">
            <form class="row">
              <div class="col-md-6 col-lg-3">
                <label>Filter By Ecn</label>
                <multiselect
                  v-model="filterEcn"
                  placeholder="Ecn"
                  :options="ecnList"
                  :multiple="false"
                  :showLabels="false"
                  :limit="4"
                >
                </multiselect>
              </div>
              <div class="col-md-6 col-lg-3">
                <label>Cusip</label>
                <input
                  class="form-control"
                  v-model="searchValue"
                  style="height: 40px"
                />
              </div>
              <div class="col-md-6 col-lg-3">
                <label>Filter By Offer Exists</label>
                <multiselect
                  v-model="offerExistType"
                  placeholder=""
                  track-by="value"
                  label="name"
                  :options="offerExistTypeList"
                  :multiple="false"
                  :showLabels="false"
                  :limit="4"
                >
                </multiselect>
              </div>
              <div class="col-md-6 col-lg-3">
                <label>Filter by held-off reason</label>
                <multiselect
                  v-model="heldOffReason"
                  :options="heldOffReasonValues"
                  :multiple="false"
                  :showLabels="false"
                  :limit="4"
                >
                </multiselect>
                <!-- <toggle-button :sync="true" v-model="showHeldOffOnly" @change="changeHeldOffOnly()"/> -->
              </div>
              <div class="col-md-6 col-lg-3 mt-4">
                <label>Show Pending Only?</label>
                <toggle-button
                  :sync="true"
                  v-model="showPendingOnly"
                  @change="changePendingToggle()"
                />
              </div>
              <div class="col-md-6 col-lg-3 mt-4">
                <label>Show Reupload Only?</label>
                <toggle-button
                  :sync="true"
                  v-model="showReuploadedOnly"
                  @change="changeReuploadToggle()"
                />
              </div>

              <div class="col-md-6 col-lg-3 text-center">
                <button
                  @click="clearFilter()"
                  type="button"
                  class="btn btn-secondary rounded mt-3"
                >
                  Clear
                </button>
                <button
                  @click="getArbsList('filter')"
                  type="button"
                  class="btn btn-primary rounded mt-3"
                >
                  Filter
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12">
          <div class="card vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader">
                <img src="@/assets/img/loader.svg" alt="" />
              </div>
              <table
                class="table align-items-center table-flush table-hover bidtbl"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort text-center">CUSIP</th>
                    <th scope="col" class="sort text-center">QTY</th>
                    <th scope="col" class="sort text-center">PRICE</th>
                    <th scope="col" class="sort text-center">BAL/MIN/INC</th>
                    <th scope="col" class="sort text-center">ECN</th>
                    <th scope="col" class="sort text-center">
                      ECN <br />
                      Price(s)
                    </th>
                    <th scope="col" class="sort text-center">
                      NOT ON <br />
                      ECNs
                    </th>
                    <th scope="col" class="sort text-center">STATUS</th>
                    <th
                      scope="col"
                      class="sort text-center border-right"
                      data-toggle="tooltip"
                      data-placement="left"
                      title="Whether offer already exists through IMS/Arbs"
                    >
                      OFFER <br />
                      EXIST
                    </th>
                    <th scope="col" class="sort text-center">
                      SEND <br />
                      QTY
                    </th>
                    <th scope="col" class="sort text-center">
                      SEND MIN. <br />
                      QTY
                    </th>
                    <th scope="col" class="sort text-center">
                      SUGGESTED <br />
                      PRICE
                    </th>
                    <th scope="col" class="sort text-center">
                      SEND <br />
                      TO ECN
                    </th>
                    <th
                      scope="col"
                      class="sort text-center"
                      v-if="showForwardedArbsOnly"
                    >
                      TRADER
                    </th>
                    <th scope="col" class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="arbsList.length == 0 && !loading">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr
                    v-for="(offer, i) in arbsList"
                    :key="i"
                    v-bind:class="{
                      'cancel-bid-row': offer.status == 'DELETED'
                    }"
                  >
                    <td class="text-center">
                      <span class="cusips">{{ offer.cusip }}</span
                      ><br />
                      <span
                        data-toggle="tooltip"
                        data-placement="left"
                        v-bind:title="offer.cusipDescription"
                        >{{
                          offer.cusipDescription | truncate(20, '...')
                        }}</span
                      >
                    </td>
                    <td class="text-center">{{ offer.qty }}</td>
                    <!-- <td class="text-center">{{offer.minQty}}</td> -->
                    <td class="text-center">{{ offer.price | currency }}</td>
                    <td class="text-center">
                      {{
                        (offer.minBalRem ? offer.minBalRem : 'NA') +
                        '/' +
                        (offer.minQty ? offer.minQty : 'NA') +
                        '/' +
                        (offer.minIncr ? offer.minIncr : 'NA')
                      }}
                    </td>
                    <td class="text-center">{{ offer.ecn.toString() }}</td>
                    <td class="text-center">
                      <div style="display: grid; text-align: left">
                        <span v-if="offer.ibpPrice" class="text-danger"
                          >IBP : {{ offer.ibpPrice | currency }}</span
                        >
                        <span v-if="offer.tmcPrice" class="text-success"
                          >TMC : {{ offer.tmcPrice | currency }}</span
                        >
                        <span v-if="offer.twdPrice" class="text-primary"
                          >TWD : {{ offer.twdPrice | currency }}</span
                        >
                        <span v-if="offer.mktxPrice" class="text-primary"
                          >MKTX : {{ offer.mktxPrice | currency }}</span
                        >
                      </div>
                    </td>
                    <td class="text-center">
                      {{ offer.notInEcns.toString() }}
                    </td>
                    <td class="text-center">{{ offer.status }}</td>
                    <td class="text-center border-right">
                      {{ offer.offerExists.toString() }}
                    </td>
                    <td class="text-center" style="width: 65px">
                      <input
                        v-if="offer.status == 'ACTIVE'"
                        maxlength="8"
                        @keypress="isQuantity($event)"
                        class="form-control"
                        v-model="offer.sendQty"
                      />
                      <span v-else>{{ offer.sendQty }}</span>
                    </td>
                    <td class="text-center" style="width: 65px">
                      <input
                        v-if="offer.status == 'ACTIVE'"
                        maxlength="8"
                        @keypress="isQuantity($event)"
                        class="form-control"
                        v-model="offer.sendMinQty"
                      />
                      <span v-else>{{ offer.sendMinQty }}</span>
                    </td>
                    <td class="text-center" style="width: 65px">
                      <input
                        v-if="offer.status == 'ACTIVE'"
                        type="number"
                        class="form-control"
                        v-model="offer.sendSuggestedPrice"
                      />
                      <span v-else>{{ offer.sendSuggestedPrice | currency }}</span>
                    </td>
                    <td class="text-center">
                      <multiselect
                        v-if="offer.status == 'ACTIVE'"
                        v-model="offer.toBeSendToEcns"
                        placeholder="Ecn"
                        :options="ecnList"
                        :multiple="true"
                        :showLabels="false"
                        :limit="4"
                      >
                      </multiselect>
                      <span v-else>{{ offer.toBeSendToEcns.toString() }}</span>
                    </td>
                    <td class="text-center" v-if="showForwardedArbsOnly">
                      {{ offer.userFirstName }} {{ offer.userLastName }}
                    </td>

                    <td class="text-left">
                      <button
                        v-if="
                          (offer.status == 'ACTIVE' ||
                            offer.status == 'DO_NOT_SEND') &&
                          offer.offeringId
                        "
                        @click="editOffer(offer)"
                        type="button"
                        class="btn btn-primary rounded"
                      >
                        Offering
                      </button>
                      <!-- <button type="button" class="btn btn-primary rounded">Save</button> -->
                      <a
                        v-if="offer.status == 'ACTIVE'"
                        @click="saveArbs(offer)"
                        title="Save"
                        class="btn ibtn btn-outline-success"
                        ><i class="fas fa-save mb-2"></i
                      ></a>
                      <a
                        v-if="offer.status == 'ACTIVE'"
                        @click="createOffer(offer)"
                        title="Create Offer"
                        class="btn ibtn btn-outline-success"
                        ><i class="fas fa-plus mb-2"></i
                      ></a>
                      <a
                        v-if="offer.status == 'ACTIVE'"
                        @click="doNotSend(offer)"
                        title="Mark as Do Not Send"
                        class="btn ibtn btn-outline-danger"
                        ><i class="fas fa-ban mb-2"></i
                      ></a>
                      <a
                        v-if="offer.status == 'DO_NOT_SEND'"
                        @click="doNotSendUnMark(offer)"
                        title="Unmark"
                        class="btn ibtn btn-outline-success"
                        ><i class="fas fa-check mb-2"></i
                      ></a>

                      <!-- <a v-if="offer.status == 'ACTIVE'" @click="deleteArbs(offer)" title="Delete" class="btn ibtn btn-outline-danger"><i class="fas fa-trash-alt mb-2"></i></a> -->
                    </td>
                  </tr>
                </tbody>
              </table>
              <nav
                aria-label="Page navigation example"
                v-if="!(arbsList.length == 0)"
              >
                <ul class="pagination justify-content-center">
                  <li
                    class="page-item"
                    v-bind:class="{ disabled: !prevCursor }"
                  >
                    <a
                      class="page-link cursor-pointer"
                      @click="nextOrPrev('prev')"
                    >
                      <i class="fa fa-angle-left"></i>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item active">
                    <a class="page-link">{{ currentPage }}</a>
                  </li>
                  <li
                    class="page-item"
                    v-bind:class="{ disabled: !nextCursor }"
                  >
                    <a
                      class="page-link cursor-pointer"
                      @click="nextOrPrev('next')"
                    >
                      <i class="fa fa-angle-right"></i>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <!-- Pagination-->
              <!-- <b-pagination
                          class="mt-4"
                          :total-rows="totalRows"
                          v-model="currentPage"
                          :per-page="perPage"
                          @input="getArbsList(currentPage)"
                      ></b-pagination>
                      <div class="total-records">
                          <span>Total Records : {{totalRows}}</span>
                      </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-offer
      v-if="editOfferModalOpen"
      v-bind:offerCusip="offerCusip"
      v-bind:selectedOffer="selectedOffer"
      v-bind:mode="'EDIT'"
      v-bind:platform="'ARBS'"
      @close="editOfferModalOpen = false"
    >
    </add-offer>
    <DoNotARB v-if="donotarbModalOpen" @close="donotarbModalOpen = false">
    </DoNotARB>
  </div>
</template>
<script>
import AWS from 'aws-sdk/global'
import config from '@/config'
import authService from '@/authService'
import addOffer from '../ims-offering/ImsAddOfferModal'
import DoNotARB from './DoNotArbsModal'

export default {
  name: 'imsCusipComponent',
  components: {
    addOffer,
    DoNotARB
  },
  data () {
    return {
      accessToken: null,
      loading: false,
      currentPage: 1,
      perPage: 20,
      searchValue: '',
      totalRows: 0,
      sortColumn: '',
      sortOrder: 'DESC',
      fileName: null,
      arbsList: [],
      selectedEcn: 'ibp',
      ecnList: ['TWD', 'IBP', 'TMC', 'MKTX'],
      spread: null,
      loadingUpload: false,
      showFilters: false,
      filterEcn: [],
      editOfferModalOpen: false,
      arbsUploadStatus: localStorage.getItem('ARBSUPLOADSTATUS'),
      accountId: '',
      accountList: [],
      filterTrader: null,
      traderList: [],
      isUserTest: authService.getUser().id === 1,
      isApiRunning: false,
      forwardedBy: [],
      userList: [],
      showForwardedArbsOnly: false,
      showPendingOnly: false,
      showReuploadedOnly: false,
      cursor: '',
      nextCursor: null,
      prevCursor: null,
      showHeldOffOnly: false,
      countLoading: false,
      arbsFeedCount: {},
      offerExistType: '',
      offerExistTypeList: [
        { name: 'Traded', value: 'TRADED' },
        { name: 'Partially Traded', value: 'PARTIALLY_TRADED' }
      ],
      donotarbModalOpen: false,
      heldOffReason: '',
      heldOffReasonValues: [
        'SPAM',
        'DO_NOT_ARB',
        'DO_NOT_ARB_FILE',
        'ORDER_FAILURE',
        'ANY'
      ],
      feedType: localStorage.getItem('ARBSFEEDTYPE')
        ? localStorage.getItem('ARBSFEEDTYPE') == 'MUNIS'
          ? false
          : true
        : false // false for munis, true for corps
    }
  },
  methods: {
    feedTypeChanged () {
      if (!this.feedType) {
        localStorage.setItem('ARBSFEEDTYPE', 'MUNIS')
      } else {
        localStorage.setItem('ARBSFEEDTYPE', 'CORPS')
      }
      this.getArbsList('filter')
      this.getFeedRecap()
    },
    showDonotarbModal () {
      this.donotarbModalOpen = !this.donotarbModalOpen
    },
    getFeedRecap () {
      this.countLoading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/arbs-feed/summary?cognitoSub=' +
            authService.getUser().cognitoSub +
            '&isMuni=' +
            !this.feedType,
          auth
        )
        .then(() => {
          this.countLoading = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    doNotSend (offer) {
      var message =
        "Are you sure you want to mark this offer as 'DO NOT SEND'? You will need to manually unmark it later to send arbs for it."
      this.$confirm(message, 'Do Not Send', 'question', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(() => {
        this.loading = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        this.$http
          .put(
            config.baseUrlAutoBidder + '/arbs-feed/do-not-send?id=' + offer.id,
            {},
            auth
          )
          .then(() => {
            this.loading = false
            this.$alert("Offer marked as 'DO NOT SEND'.", '', 'success')
            this.getArbsList()
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    doNotSendUnMark (offer) {
      var message =
        'Are you sure you want to unmark this offer? This will allow you to send arbs for it.'
      this.$confirm(message, 'Unmark Offer', 'question', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(() => {
        this.loading = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        this.$http
          .put(
            config.baseUrlAutoBidder + '/arbs-feed/do-not-send?id=' + offer.id,
            {},
            auth
          )
          .then(() => {
            this.loading = false
            this.$alert('Offer unmarked.', '', 'success')
            this.getArbsList()
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    suspendAll (type) {
      var message = `Are you sure you want to suspend all ${
        type == 'munis' ? 'Municipal' : 'Corporates'
      } offers?`
      this.$confirm(message, 'Suspend', 'question', {
        confirmButtonText: 'Suspend',
        cancelButtonText: 'No'
      }).then(() => {
        this.loading = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        this.$http
          .post(
            config.baseUrlAutoBidder + '/offer/arbs-feed-suspend-all',
            {
              cognitoSub: authService.getUser().cognitoSub,
              showForwardedOnly: this.showForwardedArbsOnly,
              forwardedBy: this.forwardedBy.map(e => {
                return e.cognitoSub
              }),
              isMuni: type == 'munis' ? true : false
            },
            auth
          )
          .then(() => {
            this.loading = false
            localStorage.setItem('ARBSUPLOADSTATUS', 'INPROGRESS')
            this.arbsUploadStatus = localStorage.getItem('ARBSUPLOADSTATUS')
            this.$alert('Suspend in progress.', '', 'success')
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    clearData () {
      var message = 'Are you sure you want to clear ARBS?'
      this.$confirm(message, 'Clear ARBS', 'question', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(() => {
        this.loadingUpload = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        this.$http
          .post(
            config.baseUrlBidSide + '/arbs/purge-user-data',
            {
              cognitoSub: authService.getUser().cognitoSub
            },
            auth
          )
          .then(() => {
            this.loadingUpload = false
            this.$alert('Arbs data is being cleared', '', 'success')
            this.getArbsList()
            localStorage.setItem('ARBSUPLOADSTATUS', 'INPROGRESS')
            this.arbsUploadStatus = localStorage.getItem('ARBSUPLOADSTATUS')
          })
          .catch(() => {
            this.loadingUpload = false
          })
      })
    },
    saveArbs (offer) {
      let cusipType = offer.offeringTypeId === 1 ? 'Munis' : 'Corporates'
      if (cusipType == 'Munis' && offer.sendQty % 5 != 0) {
        this.$alert('Send Quantity is not multiples of 5', '', 'error')
        return
      }
      if (cusipType == 'Munis' && offer.sendMinQty % 5 != 0) {
        this.$alert('Send Minimum Quantity is not multiples of 5', '', 'error')
        return
      }
      if (offer.toBeSendToEcns.length == 0) {
        this.$alert('Send To Ecn is required', '', 'error')
        return
      }
      if (!offer.sendSuggestedPrice) {
        this.$alert('Suggested price is required', '', 'error')
        return
      }
      if (!offer.sendQty) {
        this.$alert('Send quantity is required', '', 'error')
        return
      }
      if (!offer.sendMinQty) {
        this.$alert('Send minimum quantity is required', '', 'error')
        return
      }

      if (Number(offer.sendQty) < Number(offer.sendMinQty)) {
        this.$alert(
          'Minimum quantity has to be less than or equal to send quantity',
          '',
          'error'
        )
        return
      }
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let data = {
        id: offer.id,
        sendSuggestedPrice: offer.sendSuggestedPrice,
        sendQty: offer.sendQty,
        sendMinQty: offer.sendMinQty,
        notInEcns: offer.notInEcns,
        toBeSendToEcns: offer.toBeSendToEcns
        // "updateByCognitoSub" : authService.getUser().cognitoSub
      }
      this.$http
        .put(config.baseUrlAutoBidder + '/arbs-feed/update', data, auth)
        .then(() => {
          this.loading = false
          this.$alert('Offer updated.', '', 'success')
          this.getArbsList()
        })
        .catch(() => {
          this.loading = false
        })
    },
    uploadAll (type) {
      var message = `Are you sure you want to upload all ${
        type == 'munis' ? 'Municipal' : 'Corporates'
      } offers?`
      this.$confirm(message, 'Upload', 'question', {
        confirmButtonText: 'Upload',
        cancelButtonText: 'No'
      }).then(() => {
        this.loadingUpload = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        this.$http
          .put(
            config.baseUrlAutoBidder + '/offer/sendtoecn-arbs-feed',
            {
              arbsId: -1,
              cognitoSub: authService.getUser().cognitoSub,
              showForwardedOnly: this.showForwardedArbsOnly,
              forwardedBy: this.forwardedBy.map(e => {
                return e.cognitoSub
              }),
              isMuni: type == 'munis' ? true : false
            },
            auth
          )
          .then(() => {
            this.loadingUpload = false
            this.$alert('Offer upload in progress', '', 'success')
            this.getArbsList()
            localStorage.setItem('ARBSUPLOADSTATUS', 'INPROGRESS')
            this.arbsUploadStatus = localStorage.getItem('ARBSUPLOADSTATUS')
          })
          .catch(() => {
            this.loadingUpload = false
          })
      })
    },
    createOffer (offer) {
      var message = 'Are you sure you want to create a new offer?'
      this.$confirm(message, 'Create Offer', 'question', {
        confirmButtonText: 'Create',
        cancelButtonText: 'No'
      }).then(() => {
        this.loading = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        this.$http
          .put(
            config.baseUrlAutoBidder + '/offer/sendtoecn-arbs-feed',
            {
              arbsId: offer.id,
              cognitoSub: authService.getUser().cognitoSub,
              showForwardedOnly: this.showForwardedArbsOnly,
              forwardedBy: this.forwardedBy.map(e => {
                return e.cognitoSub
              })
            },
            auth
          )
          .then(() => {
            this.loading = false
            this.$alert('Offer creation in progress', '', 'success')
            this.getArbsList()
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    deleteArbs (offer) {
      var message = 'Are you sure you want to delete?'
      this.$confirm(message, 'Delete', 'question', {
        confirmButtonText: 'Delete',
        cancelButtonText: 'No'
      }).then(() => {
        this.loading = true
        const auth = {
          headers: { 'org-token': authService.getOrgToken() }
        }
        this.$http
          .put(
            config.baseUrlBidSide +
              '/arbs/delete?arbsProcessedId=' +
              offer.id +
              '&updateByCognitoSub=' +
              authService.getUser().cognitoSub,
            {},
            auth
          )
          .then(() => {
            this.loading = false
            this.getArbsList()
          })
          .catch(() => {
            this.loading = false
          })
      })
    },
    clearUploadForm () {
      this.fileName = null
      document.getElementById('file-upload').value = null
    },
    uploadArbsFile () {
      if (this.loading) {
        return
      }
      this.upload('input')
    },
    uploadFileToIBP (filePath) {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let data = {
        //   "userId" : authService.getUser().id,
        key: filePath,
        cognitoSub: authService.getUser().cognitoSub
      }
      this.$http
        .post(config.baseUrlBidSide + '/arbs/upload-ibp', data, auth)
        .then(() => {
          this.loading = false
          // this.$alert("The file has been successfully uploaded. The file is being processed.","","success");
          this.clearUploadForm()
          this.getArbsList()
        })
        .catch(e => {
          console.log('Error', e)
          this.loading = false
        })
    },
    uploadFileToTMC (filePath) {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let data = {
        //   "userId" : authService.getUser().id,
        key: filePath,
        cognitoSub: authService.getUser().cognitoSub
      }
      this.$http
        .post(config.baseUrlBidSide + '/arbs/upload-tmc', data, auth)
        .then(() => {
          this.loading = false
          //this.$alert("The file has been successfully uploaded. The file is being processed.","","success");
          this.clearUploadForm()
          this.getArbsList()
        })
        .catch(e => {
          console.log('Error', e)
          this.loading = false
        })
    },
    uploadFileToTWR (filePath) {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let data = {
        //   "userId" : authService.getUser().id,
        key: filePath,
        cognitoSub: authService.getUser().cognitoSub
      }
      this.$http
        .post(config.baseUrlBidSide + '/arbs/upload-twd', data, auth)
        .then(() => {
          this.loading = false
          //this.$alert("The file has been successfully uploaded. The file is being processed.","","success");
          this.clearUploadForm()
          this.getArbsList()
        })
        .catch(e => {
          console.log('Error', e)
          this.loading = false
        })
    },
    upload (albumName) {
      var s3 = new AWS.S3({
        apiVersion: '2006-03-01',
        params: { Bucket: 'imsfileupload' }
      })
      var files = document.getElementById('file-upload').files
      if (!files.length) {
        return alert('Please choose a file to upload first.')
      }
      var file = files[0]
      var fileName = file.name
      var albumPhotosKey = encodeURIComponent(albumName) + '/'
      var UUID = this.uuidv4()
      console.log(UUID)
      var photoKey = albumPhotosKey + fileName
      var imsFolderName = '/arbs_' + this.selectedEcn + '/'
      var albumBucketName = config.albumBucketNameIms + imsFolderName + UUID
      console.log(photoKey)
      this.loading = true
      // Use S3 ManagedUpload class as it supports multipart uploads
      var self = this
      localStorage.setItem('ARBSUPLOADSTATUS', 'INPROGRESS')
      self.arbsUploadStatus = localStorage.getItem('ARBSUPLOADSTATUS')
      s3.upload(
        { Key: file.name, Bucket: albumBucketName, Body: file, ACL: 'private' },
        function (err) {
          this.fileuploading = false
          if (err) {
            console.log(err, 'there was an error uploading your file')
            self.loading = false
            self.arbsUploadStatus = null
            localStorage.removeItem('ARBSUPLOADSTATUS')
            self
              .$alert(
                'File upload session expired. Please try again.',
                '',
                'error'
              )
              .then(() => {
                window.location.reload()
              })
          } else {
            if (self.selectedEcn == 'ibp') {
              self.uploadFileToIBP('arbs_ibp/' + UUID + '/' + file.name)
            }
            if (self.selectedEcn == 'tmc') {
              self.uploadFileToTMC('arbs_tmc/' + UUID + '/' + file.name)
            }
            if (self.selectedEcn == 'twd') {
              self.uploadFileToTWR('arbs_twd/' + UUID + '/' + file.name)
            }
          }
        }
      )
    },
    onFileChange (e) {
      const file = e.target.files[0]
      this.fileName = file.name
    },
    search () {},
    clearFilter () {
      this.filterEcn = []
      this.searchValue = ''
      this.offerExistType = ''
      this.heldOffReason = []
      this.getArbsList('filter')
    },
    clearSearch () {
      this.searchValue = ''
      this.getArbsList()
    },
    sort (column) {
      this.sortColumn = column
      this.sortOrder =
        this.sortOrder == 'ASC'
          ? (this.sortOrder = 'DESC')
          : (this.sortOrder = 'ASC')
      //this.getCustomers();
    },
    saveSpread () {
      let dataToSend = [
        {
          setting: 'ARBS_FEED_SPREAD',
          dataType: 'NUMERIC',
          value: this.spread
        }
      ]
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .post(config.baseUrlBidSide + '/tradebook/setting', dataToSend, auth)
        .then(() => {
          this.loading = false
          this.$alert('Saved successfully ', '', 'success')
          this.getArbsList()
        })
        .catch(e => {
          console.log(e)
        })
    },
    getUserSetting () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/tradebook/setting-list?cognitoSub=' +
            authService.getUser().cognitoSub,
          auth
        )
        .then(result => {
          this.userSettings = result.data
          this.userSettings.forEach(element => {
            if (element.setting == 'ARBS_FEED_SPREAD') {
              this.spread = element.value
            }
            if (element.setting == 'ARBS_ACCOUNT') {
              this.accountId = element.value
            }
          })
          this.getArbsList()
        })
        .catch(e => {
          console.log(e)
        })
    },
    getAccountList () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(config.baseUrlBidSide + '/account/customer-account', auth)
        .then(result => {
          this.accountList = result.data
          this.getUserSetting()
        })
        .catch(e => {
          console.log(e)
        })
    },
    changePendingToggle () {
      if (this.showPendingOnly) this.showReuploadedOnly = false
      this.getArbsList('filter')
    },
    changeReuploadToggle () {
      if (this.showReuploadedOnly) this.showPendingOnly = false
      this.getArbsList('filter')
    },
    changeHeldOffOnly () {
      this.getArbsList('filter')
    },
    nextOrPrev (nextOrPrev) {
      if (!this.loading) this.getArbsList(nextOrPrev)
    },
    getArbsList (mode) {
      this.loading = true
      this.isApiRunning = true

      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      if (mode == 'next') {
        this.cursor = this.nextCursor
        if (!this.nextCursor) return
      }
      if (mode == 'prev') {
        this.cursor = this.prevCursor
        if (!this.prevCursor) return
      }
      if (mode == 'filter') {
        this.cursor = ''
      }
      console.log(this.filterEcn)

      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/arbs-feed/list-v2?cursor=' +
            this.cursor +
            '&size=' +
            this.perPage +
            '&search=' +
            this.searchValue +
            '&sortColumn=' +
            this.sortColumn +
            '&sortOrder=' +
            this.sortOrder +
            '&cognitoSub=' +
            (this.filterTrader
              ? this.filterTrader.cognitoSub
              : authService.getUser().cognitoSub) +
            '&showPendingOnly=' +
            this.showPendingOnly +
            '&showReuploadedOnly=' +
            this.showReuploadedOnly +
            '&heldOffReason=' +
            (this.heldOffReason ? this.heldOffReason : '') +
            // "&showHeldOffOnly="+
            // this.showHeldOffOnly+
            '&status=ACTIVE' +
            '&offerExistType=' +
            (this.offerExistType ? this.offerExistType.value : '') +
            // (this.forwardedBy.length ? this.forwardedBy.map((e) => {return e.cognitoSub}).toString()  : "")+
            '&ecn=' +
            (this.filterEcn ? this.filterEcn : '') +
            '&isMuni=' +
            (!this.feedType ? 'true' : 'false'),
          auth
        )
        .then(result => {
          this.nextCursor = result.data.pageInfo.nextCursor
          this.prevCursor = result.data.pageInfo.prevCursor
          result.data.content.forEach(data => {
            data.toBeSendToEcns =
              data.toBeSendToEcns.length > 0
                ? data.toBeSendToEcns
                : data.notInEcns
            data.sendQty = data.sendQty ? data.sendQty : data.qty
            data.sendMinQty =
              data.sendMinQty === null ? data.minQty : data.sendMinQty
            data.sendSuggestedPrice = data.sendSuggestedPrice
              ? data.sendSuggestedPrice.toFixed(3)
              : (data.price + Number(data.spreadUsed)).toFixed(3)
          })
          this.arbsList = result.data.content
          this.loading = false
          this.isApiRunning = false
          if (mode == 'next') {
            this.currentPage = this.currentPage + 1
          }
          if (mode == 'prev') {
            this.currentPage = this.currentPage - 1
          }
        })
        .catch(e => {
          console.log('Error', e)
          this.isApiRunning = false
          this.loading = false
        })
    },
    editOffer (offer) {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(config.baseUrlBidSide + '/offer/' + offer.offeringId, auth)
        .then(result => {
          this.loading = false
          this.selectedOffer = result.data
          let cusip = {}
          cusip.cusip = offer.cusip
          cusip.maturityDate = offer.maturityDate
          cusip.callDate = offer.callDate
          cusip.coupon = offer.coupon
          cusip.stateId = offer.stateId
          cusip.id = offer.cusipId
          cusip.offeringTypeId = offer.offeringTypeId
          this.offerCusip = cusip
          this.editOfferModalOpen = true
        })
    },
    getTraderList () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader',
          auth
        )
        .then(result => {
          this.traderList = result.data.content
        })
        .catch(e => {
          console.log(e)
        })
    },
    getUserList () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/user/list?page=1&size=1000&search=&status=&sortColumn=firstName&sortOrder=ASC&group&showForwarders=true&cognitoSub=' +
            authService.getUser().cognitoSub,
          auth
        )
        .then(result => {
          this.userList = result.data.content
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  mounted () {
    this.getAccountList()
    this.$root.$on('ARBS_OFFER_UPDATED', () => {
      if (!this.isApiRunning) {
        this.getArbsList()
      }
      this.getFeedRecap()
    })
    this.$root.$on('ARBSUPLOADCOMPLETED', () => {
      this.arbsUploadStatus = null
      this.getFeedRecap()
    })
    this.$root.$on('ARBS_OFFER_UPDATED', () => {
      this.arbsUploadStatus = null
      this.getFeedRecap()
    })
    this.$root.$on('arbsfeedcount', data => {
      this.arbsFeedCount = JSON.parse(data.count)
    })
    if (this.isUserTest) {
      this.getTraderList()
    }
    this.getUserList()
    this.getFeedRecap()
  },
  beforeDestroy () {
    this.$root.$off('ARBS_FEED_OFFER_UPDATED')
    this.$root.$off('ARBSUPLOADCOMPLETED')
    this.$root.$off('ARBS_OFFER_UPDATED')
    this.$root.$off('arbsfeedcount')
  },
  created () {
    let self = this
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log('accessToken is not found', err)
      } else {
        this.accessToken = result
      }
    })
    const userPoolLoginKey = config.userPoolLoginKey
    const logins = {}
    logins[userPoolLoginKey] = this.accessToken
    AWS.config.region = config.region
    const cognitoParams = {
      IdentityPoolId: config.IdentityPoolIdFileUpload,
      Logins: logins
    }
    let cognitoidentity = new AWS.CognitoIdentity()
    cognitoidentity.getId(cognitoParams, function (err, data) {
      if (err) {
        console.log(err)
        self.showSessionReloadPoup()
      } else {
        console.log(data.IdentityId)
        let bucketRegion = AWS.config.region
        AWS.config.update({
          region: bucketRegion,
          credentials: new AWS.CognitoIdentityCredentials(cognitoParams)
        })
      }
    })
  }
}
</script>
<style scoped>
.abs-btn-grp-arbs {
  position: absolute;
  top: 55px;
  right: 110px;
}
.recap {
  padding: 6px;
  background-color: white;
  height: 31px;
  border-radius: 19px;
  float: right;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 12px;
}
.recap span {
  padding: 6px;
  position: relative;
  bottom: 4px;
}
/* .abs-btn-grp-arbs{
  top:40px
} */
</style>
